import {tokens} from '@pleo-io/telescope'
import styled from 'styled-components'

import {gutters} from '@helios/shared/styles/grid'
import {colors} from '@helios/shared/theme'
import mq from '@helios/shared/utils/media-query'

export const Section = styled.section`
    display: grid;
    row-gap: ${tokens.spacing28};
    column-gap: ${tokens.spacing8};
    align-content: start;
`

export const Wrapper = styled(Section).attrs({as: 'footer'})`
    ${gutters};
    padding-top: ${tokens.spacing60};
    padding-bottom: ${tokens.spacing60};
    background: ${colors.background.secondary};

    ${mq.min('sm')} {
        grid-template-columns: repeat(12, 1fr);
    }

    ${mq.min('md')} {
        padding-top: 120px;
        padding-bottom: 120px;
    }
`

export const Logo = styled.img`
    width: 80px;

    ${mq.min('md')} {
        width: 90px;
    }
`

export const SocialLinks = styled.nav`
    display: grid;
    grid-auto-flow: column;
    align-items: center;
    justify-content: start;
    column-gap: ${tokens.spacing8};

    ${mq.min('sm')} {
        order: 1;
    }

    > * {
        display: flex;
    }
`

export const SocialIcon = styled.div`
    color: ${tokens.shade700};
    transition: ${tokens.fastIn};
    transition-property: color;

    a:hover & {
        color: ${tokens.shade900};
    }
`

export const Details = styled(Section)`
    grid-column: 1 / span 3;
    align-content: start;
`

export const Links = styled(Section)`
    grid-template-columns: repeat(2, 1fr);
    grid-column: 4 / -1;

    ${mq.min('sm')} {
        grid-template-columns: repeat(4, 1fr);
    }
`

export const Terms = styled(Section)`
    grid-column: 1 / -1;
    margin-top: ${tokens.spacing40};
    row-gap: ${tokens.spacing20};

    ${mq.min('sm')} {
        margin-top: 0;
    }
`

export const Address = styled.div`
    ${mq.min('sm')} {
        order: 2;
    }
`

export const SectionHeading = styled.div`
    margin-bottom: ${tokens.spacing4};
    letter-spacing: 0.2em;
`

export const LinkGroup = styled.nav`
    display: grid;
    grid-template-columns: auto;
    row-gap: ${tokens.spacing8};
    align-content: start;
    justify-items: start;
`
